//
//
//
//
//
//
//

import openFileUpload2 from "@/pccomponents/OpenFileUpload2";
import showFileList from "@/pcpage/contract/file/ShowFileList";
import * as axios from "@/store/http";
export default {
    name: "attachLoad",
    components: {
        openFileUpload2,
        showFileList
    },
    props: {
        //业务类型
        btype:{
            type: String,
            default: ""
        },
        //单据ID
        keyval:{
            type:String,
            default:'0'
        },
        //tag标识
        tagname:{
            type:String,
            default:""
        },
        //tabname
        tabname:{
            type:String,
            default:""
        },
        //单据类型
        docutypeid:{
            type:String,
            default:""
        },
        //匹配的编辑项
        matchItem:{
          type:String,
          default:""
        },
        //编辑项
        editItem:{
          type:String,
          default:""
        },
        //校验的数据对象
        record:{
          type: Object,
          default: () => ({})
        },
        //对象属性
        attr:{
          type: String,
          default: ""
        },
        //无主键试通过uuid来进行关联
        uuid:{
           type: String,
          default: ""
        },
        //是否兼容不用登陆访问
        nosession:{
          type:Boolean,
          default:false
        },
        ifshowtip:{//未保存时是否展示文字提示信息
        type:Boolean,
        default:true
      },
    },
    data() {
        return {
            fileForm: {
                  btype:this.btype,
                  docutypeid:this.docutypeid     
            },
            //附件列表
            showFileList: [],
            //获取附件列表URL
            getUpload: 'file/getfile',
            files:'1'
        }
    },
    methods: {
        /**
         * 获取附件列表
         */
        async getFileInfo() {
             let params = {
              record: {
                btype: this.btype,
                keyval: this.keyval,
                tagname: this.tagname,
                tabname:this.tabname,
                docutypeid:this.docutypeid,
                v_uuid:this.uuid
              }
            };
            console.info(params);
            await axios.post(this.getUpload, params).then(({ data }) => {
            if (data.code == "1") {//获取附件列表
                this.showFileList=data.data.filelist;
               
                } else {
                  alert(data.data.msg)
                }
              });

            this.setUpfilesVal()
         },
         /**
          *附件上传成功之后回调刷新列表
          */
         fileUploadBack() {
             this.getFileInfo();
          },

        //设置对象属性
        setUpfilesVal(){
            if(this.showFileList && this.showFileList.length > 0){
                if(this.record && this.isNotNullOrEmpty(this.attr)){
                  this.$set(this.record, this.attr, this.files);
                }
            }else{
               if(this.record && this.isNotNullOrEmpty(this.attr)){
                    this.$set(this.record, this.attr, '');
                 }
            }
           
        }
    },
    
    watch: {
      //监听主单据id变化，避免未能及时加载到数据
      keyval:{
        handler:function(val,oldval){
           if(this.nosession == true){
            this.getUpload = "onboarding/getfile";
          }
          if((val!="" && val!=undefined && val!="0") || (this.uuid != "")){
            this.getFileInfo();
          }
        },
        
        immediate:true
      },
      btype:{
          handler:function(val,oldval){
            this.$set(this.fileForm,'btype',val);
        }, 
        immediate:true
      },
      docutypeid:{
         handler:function(val,oldval){
            this.$set(this.fileForm,'docutypeid',val);
        }, 
        immediate:true
      }
    },
    computed: {
          readonly: function () {
          if(this.uuid !=""){
              if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
                  //返回true,设为只读
                  return true;
                }else{
                  return false;
                }
          }
          if(this.keyval ==='undefined' || this.keyval=="" || this.keyval == '0'){
            return true;
          }else{
            if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
              //返回true,设为只读
              return true;
            }else{
              return false;
            }
          }
        },
    },
    mounted() {
        // if(this.keyval !=0)
        // {
           // this.getFileInfo();
      //   }
    },
    created(){
      //外网的话跳过session校验
      if(this.nosession == true){
        this.getUpload = "onboarding/getfile";
      }
    }
}



// WEBPACK FOOTER //
// ./src/pccomponents/AttachLoad.vue